import {
  Button,
  Drawer,
  Form,
  Input,
  Modal,
  Select,
  Space,
  Table,
  Tooltip,
  Typography,
} from "antd";
import axios from "axios";
import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { NotificationInfo, UserInfo } from "../../../context";
import { useReactToPrint } from "react-to-print";
import {
  PrinterOutlined,
  DeleteOutlined,
  PlusOutlined,
} from "@ant-design/icons";

const ViewProductConsumption = ({ open, close, selectedData }) => {
  const { userData } = useContext(UserInfo);
  const scroll = {};
  const [rawConsumptionDetailsList, setRawConsumptionDetailsList] = useState({
    data: [],
    ready: false,
  });
  const tableLayout = "";
  const componentRef = useRef();
  const [paddingPrint, setPaddingPrint] = useState(0);
  const [displayDetailsPrint, setDisplayDetailsPrint] = useState(false);
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [selectedDataRemove, setSelectedDataRemove] = useState(null);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const { rerunNotif } = useContext(NotificationInfo);
  const [addProductToOrder, setAddProductToOrder] = useState(false);
  const [productRawList, setProductRawList] = useState({
    data: [],
    ready: false,
  });
  const [specProductInfo, setSpecProductInfo] = useState({
    data: [],
    ready: false,
  });
  const [loadings, setLoadings] = useState(false);

  const tableProps = {
    bordered: false,
    size: "medium",
    // expandable,
    showHeader: true,
    scroll,
    tableLayout,
  };

  const columns = [
    {
      title: "Product",
      //   dataIndex: "product",
      dataIndex: ["productsaverawproduct", "product"],
      sorter: (a, b) =>
        a.productsaverawproduct.product - b.productsaverawproduct.product,
      render: (text) => <p>{text}</p>,
    },
    {
      title: "Description",
      //   dataIndex: "description",
      dataIndex: ["productsaverawproduct", "description"],
      sorter: (a, b) =>
        a.productsaverawproduct.description -
        b.productsaverawproduct.description,
      render: (text) => <p>{text}</p>,
    },
    {
      title: "Unit",
      // dataIndex: "unit",
      dataIndex: ["productsaverawproduct", "rawproductsuserunit", "unit"],
      filters: [
        {
          text: "Piece(s)",
          value: "Piece(s)",
        },
        {
          text: "Bottle(s)",
          value: "Bottle(s)",
        },
        {
          text: "Vial(s)",
          value: "Vial(s)",
        },
        {
          text: "Box(s)",
          value: "Box(s)",
        },
      ],
      onFilter: (value, record) =>
        record.rawproductsuserunit.unit.includes(value),
      sorter: (a, b) =>
        a.rawproductsuserunit.unit.length - b.rawproductsuserunit.unit.length,
      ellipsis: true,
      render: (text) => <p>{text}</p>,
    },
    {
      title: "Consumption",
      dataIndex: "consumption",
      align: "right",
      render: (text) => <p>{text}</p>,
    },
    {
      title: "",
      dataIndex: "",
      align: "center",
      render: (text) => (
        <p style={{ display: displayDetailsPrint ? "none" : "block" }}>
          <Tooltip title="Delete">
            <Button
              type="dashed"
              shape="circle"
              onClick={() => {
                setSelectedDataRemove(text);
                setDeleteDialog(true);
              }}
              icon={<DeleteOutlined />}
            />
          </Tooltip>
        </p>
      ),
    },
  ];

  const tableColumns = columns.map((item) => ({
    ...item,
    ellipsis: false,
  }));

  const getRawConsumptionDetails = useCallback(() => {
    var params = {
      user_id: userData.data.id,
      product_id: selectedData !== null ? selectedData.id : "",
    };
    axios
      .get("user/commissary/product/consumption-raw-info", {
        params,
      })
      .then((response) => {
        const data = response.data;
        setRawConsumptionDetailsList({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.id, selectedData]);

  const getRawProductList = useCallback(() => {
    var params = { user_id: userData.data.id, is_production: "all" };
    axios
      .get("user/commissary/raw-product-list", {
        params,
      })
      .then((response) => {
        const data = response.data;
        setProductRawList({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.id]);

  useEffect(() => {
    getRawConsumptionDetails();
    getRawProductList();
  }, [getRawConsumptionDetails, getRawProductList]);

  const handleAddRawProductToFProduct = (values) => {
    const formdata = new FormData();
    formdata.append("user_id", userData.data.id);
    formdata.append("product_id", selectedData.id);
    formdata.append("commissary_id", selectedData.commissary_id);

    for (const name in values) {
      formdata.append(name, values[name]);
    }

    setLoadings(true);
    axios
      .post("user/commissary/create-new-raw-consumption", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "product-exist") {
          rerunNotif("error", "Product already added!");
          setTimeout(() => {
            setLoadings(false);
          }, 1000);
        }
        if (data === "success") {
          rerunNotif("success", "New raw product added successfully.");
          setTimeout(() => {
            setAddProductToOrder(false);
            setLoadings(false);
            getRawConsumptionDetails();
          }, 1000);
        }
      })
      .catch((error) => {
        setLoadings(false);
      });
  };

  const handleFetchProduct = (rawID) => {
    var params = {
      raw_id: rawID,
      user_id: userData.data.id,
    };
    setSpecProductInfo({ data: [], ready: false });
    setLoadings(true);
    axios
      .get("user/commissary/spec-product-info", {
        params,
      })
      .then((response) => {
        const data = response.data;
        setLoadings(false);
        setSpecProductInfo({ data, ready: true });
      })
      .catch((error) => {
        setLoadings(false);
        console.log("ERROR: ", error);
      });
  };

  const handleOk = () => {
    setConfirmLoading(true);
    setTimeout(() => {
      setDeleteDialog(false);
      setConfirmLoading(false);
      handleDeleteProductInConsumption();
    }, 2000);
  };

  const handleDeleteProductInConsumption = () => {
    const formdata = new FormData();
    formdata.append("user_id", userData.data.id);
    formdata.append(
      "id",
      selectedDataRemove !== null ? selectedDataRemove.id : ""
    );
    setLoadings(true);
    axios
      .post("user/commissary/delete-raw-consumption", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Delete raw consumption successfully.");
          setTimeout(() => {
            setLoadings(false);
            getRawConsumptionDetails();
          }, 1000);
        }
      })
      .catch((error) => {
        console.log("Error: ", error);
        setLoadings(false);
      });
  };

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,

    onBeforeGetContent: () => {
      return new Promise((resolve) => {
        setPaddingPrint(10);
        setDisplayDetailsPrint(true);
        resolve();
      });
    },
    onAfterPrint: () => {
      setPaddingPrint(0);
      setDisplayDetailsPrint(false);
    },
  });

  return (
    <Drawer
      title="Consumption Details"
      width={window.innerWidth > 500 ? 600 : "100vw"}
      onClose={close}
      open={open}
      bodyStyle={{
        paddingBottom: 80,
      }}
    >
      {selectedData !== null && (
        <>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginBottom: 5,
            }}
          >
            <div style={{ flexGrow: 1 }} />
            <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={() => setAddProductToOrder(true)}
            >
              Raw Product
            </Button>
          </div>

          <div
            style={{ overflowX: "auto", padding: paddingPrint }}
            ref={componentRef}
          >
            {displayDetailsPrint && (
              <Typography.Title level={4} style={{ marginBottom: 15 }}>
                {selectedData.product} - Raw Consumption
              </Typography.Title>
            )}
            <Table
              {...tableProps}
              pagination={false}
              columns={tableColumns}
              dataSource={
                rawConsumptionDetailsList.data.length > 0
                  ? rawConsumptionDetailsList.data
                  : []
              }
              scroll={scroll}
              rowKey={(record) => record.id}
            />
          </div>
        </>
      )}
      <div style={{ display: "flex", marginTop: 10 }}>
        <div style={{ flexGrow: 1 }} />
        <div>
          <Button
            type="primary"
            onClick={handlePrint}
            icon={<PrinterOutlined />}
          >
            Print
          </Button>
        </div>
      </div>

      <Modal
        title="Are you sure to delete this product ?"
        open={deleteDialog}
        onOk={handleOk}
        confirmLoading={confirmLoading}
        onCancel={() => setDeleteDialog(false)}
      />

      <Modal
        title=""
        open={addProductToOrder}
        onCancel={() => setAddProductToOrder(false)}
        footer={null}
        // width={350}
      >
        <Form
          layout="vertical"
          name="basic"
          initialValues={{ remember: false }}
          onFinish={handleAddRawProductToFProduct}
          autoComplete="off"
        >
          <Space
            direction="vertical"
            style={{ width: "100%", margin: 0, marginTop: 20 }}
          >
            <Form.Item
              name="raw_id"
              label="Product"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <Select
                placeholder="Select product"
                onChange={(e) => {
                  handleFetchProduct(e);
                }}
                size="large"
                showSearch
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                {productRawList.data.length > 0 ? (
                  productRawList.data.map((data, index) => (
                    <Select.Option value={data.raw_id} key={index}>
                      {data.product}
                    </Select.Option>
                  ))
                ) : (
                  <Select.Option value="">No raw product found!</Select.Option>
                )}
              </Select>
            </Form.Item>

            {specProductInfo.ready && specProductInfo.data && (
              <>
                <Form.Item label="Unit">
                  <Input
                    placeholder="Set firstname"
                    size="large"
                    defaultValue={
                      specProductInfo.data[0].rawproductsuserunit.unit
                    }
                    disabled
                  />
                </Form.Item>

                <Form.Item
                  name="consumption"
                  label="Quantity Consumption"
                  rules={[
                    {
                      required: true,
                      message: "Required",
                    },
                  ]}
                >
                  <Input
                    placeholder="Set quantity consumption"
                    size="large"
                    style={{ width: "100%" }}
                  />
                </Form.Item>
              </>
            )}
          </Space>

          <Form.Item style={{ marginTop: "20px" }}>
            <Button
              type="primary"
              loading={loadings}
              htmlType="submit"
              style={{ width: "100%", borderRadius: "20px" }}
            >
              {loadings ? "Loading" : "Add"}
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </Drawer>
  );
};

export default ViewProductConsumption;
